var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { Group } from '@/models/Group';
import { Step } from '@/models/Step';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sanitizeString } from '@/support/String';
import { RolesEnum } from '@/items/Roles';
let Steps = class Steps extends Vue {
    constructor() {
        super(...arguments);
        this.steps = [];
        this.newStep = new Step({ text: '' });
        this.originalValue = '';
        this.isStoring = false;
        this.isUploading = false;
        this.fileName = '';
        this.isShowingDialog = false;
        this.isLoading = true;
        this.selectedStep = null;
        this.fileInput = null;
    }
    get editorOptions() {
        return {
            placeholder: this.$t('steps.placeholder'),
            modules: {
                toolbar: true,
                magicUrl: true,
            },
        };
    }
    mounted() {
        if (this.group.exists()) {
            if (this.group.type && typeof this.group.type !== 'string' && this.group.type.label === 'parnassys') {
                this.$router.go(-1);
                return;
            }
            this.initialize();
        }
    }
    initialize() {
        new Step()
            .include(['file'])
            .group(this.group)
            .all()
            .then((steps) => {
            steps.forEach((step, index) => {
                step.editing = false;
                step.attachment = false;
                steps[index] = step;
            });
            this.steps = steps;
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoading = false;
        });
    }
    get dialogOptions() {
        const step = this.selectedStep;
        return {
            title: step.text || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.template') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!step) {
                            return;
                        }
                        step
                            .group(this.group)
                            .delete()
                            .then(() => {
                            if (step.id !== undefined) {
                                const index = this.findById(step.id);
                                this.steps.splice(index, 1);
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedStep = null;
                    },
                },
            },
        };
    }
    remove(step) {
        this.selectedStep = step;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    clear() {
        this.newStep = new Step();
        this.fileName = '';
    }
    store() {
        if (!this.newStep.text) {
            return;
        }
        this.isStoring = true;
        this.newStep.group(this.group);
        this.newStep
            .create()
            .then((step) => {
            step.editing = false;
            this.clear();
            step.editing = false;
            step.attachment = false;
            this.steps.push(step);
            this.isStoring = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isStoring = false;
        });
    }
    update(step) {
        const key = this.findById(step.id);
        step.group(this.group);
        step
            .group(this.group)
            .update()
            .then((step) => {
            this.originalValue = '';
            this.steps[key].editing = false;
            if (this.fileInput) {
                this.fileInput.removeAttribute('text');
                this.fileInput.setAttribute('text', '');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    inputChanged(event) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        this.newStep.file = files[0];
        this.fileName = files[0].name;
    }
    findById(id) {
        return this.steps.findIndex((step) => step.id === id);
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
};
__decorate([
    Prop({ default: new Group() }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Steps.prototype, "group", void 0);
Steps = __decorate([
    Component({
        components: {
            quillEditor,
            LoaderCard,
        },
    })
], Steps);
export default Steps;
